import { render, staticRenderFns } from "./PublicationHistory.vue?vue&type=template&id=52b0d63e&scoped=true"
import script from "./PublicationHistory.vue?vue&type=script&lang=js"
export * from "./PublicationHistory.vue?vue&type=script&lang=js"
import style0 from "./PublicationHistory.vue?vue&type=style&index=0&id=52b0d63e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b0d63e",
  null
  
)

export default component.exports